// extracted by mini-css-extract-plugin
module.exports = {"boxHeader":"paymentMethod_boxHeader__3upvm","removeListIndentation":"paymentMethod_removeListIndentation__2fDJ7"};